// extracted by mini-css-extract-plugin
export default {"container":"SearchWithSelect_container__DMfzY","icon":"SearchWithSelect_icon__AlITH","selectBox":"SearchWithSelect_selectBox__ECBly"};